import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import QRCodeLib from 'qrcode.react';
import style from "./styles.pcss";
var cn = classNames.bind(style);

/* из расчета width: 64px, padding: 6px, 6 * 100 / 64 */
var PADDING_VAL_IN_PERCENT = 9.375;
export var QRCode = /*#__PURE__*/memo(function (_ref) {
  var link = _ref.link,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'QRCode' : _ref$testName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 64 : _ref$size;
  var padding = useMemo(function () {
    return size / 100 * PADDING_VAL_IN_PERCENT;
  }, [size]);
  var qrSize = useMemo(function () {
    return size - padding * 2;
  }, [size, padding]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('qr-wrapper'),
    "data-component": testName
    /* eslint-disable-next-line react/forbid-dom-props */,
    style: {
      padding: "".concat(padding, "px")
    },
    "data-t-id": "src-QRCode"
  }, /*#__PURE__*/React.createElement(QRCodeLib, {
    bgColor: "transparent",
    className: cn('qr'),
    fgColor: "#fff",
    renderAs: "svg",
    size: qrSize,
    value: link
  }));
});
QRCode.displayName = QRCode.name;